import React, { Component } from 'react';

export default class Filter extends Component {

  filter (keyword) {
    if (this.props.state.users_tmp) {
      var regexp = new RegExp(keyword + '(.*?)', 'g')
      var filter_users = this.props.state.users_tmp
      if (keyword) {
        filter_users = this.props.state.users_tmp.filter(user => {
          var ret = false
          let name = ""
          if (user.lastName) {
            name = user.lastName
          }
          if (user.family_name) {
            name = user.family_name + " " + user.first_name
          }
          if (regexp.test(name)){
            ret = true;
          }
          if (regexp.test(user.address)){
            ret = true;
          }
          if (regexp.test(user.apartment)){
            ret = true;
          }
          if (regexp.test(user.tel)){
            ret = true;
          }
          return ret
        })
      }
    }

    return this.props.onChange({users: filter_users, filter: keyword, view_num: 50})
  }

  render () {
    return (
      <input type="text" value={this.props.state.filter} className="admin_filter" placeholder="Filter" onChange={e => this.filter(e.target.value)} />
    );
  }
}